/**
 * Possible display types for questions/answers.
 *
 * @author Florian Walch
 * @since 9.1
 */
export enum SessionTypes {
  OMQ_CONTACT = 'OMQ_CONTACT',
  OMQ_HELP = 'OMQ_HELP',
  OMQ_CHAT = 'OMQ_CHAT',
  OMQ_ASSIST = 'OMQ_ASSIST',
  OMQ_REPLY = 'OMQ_REPLY',
}
